import { render, staticRenderFns } from "./AcidingPage.vue?vue&type=template&id=5c95f122&"
import script from "./AcidingPage.vue?vue&type=script&lang=js&"
export * from "./AcidingPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports